import { useMemo } from "react";

import { useListingData } from "~/context/ListingPageDataContext";
import { SegmentedListingProps } from "~/types/local-types";

export const useSegmentedListing = () => {
  const { data } = useListingData();
  return useMemo(() => {
    const segmentedListingProps: SegmentedListingProps = {
      listingId: data.listingId,
      metro: data.metro,
      neighborhood: data.neighborhood,
      city: data.listingCity,
      state: data.listingState,
      zip: data.zipGoogle || "",
      country: data.listingCountry,
      useType: data.useType,
      totalReviews: data.reviews?.length || 0,
      spaceReviewCount: data.spaceReviewCount,
      spaceReviewStars: data.spaceReviewStars,
      title: data.title,
      coverImgUrl: data.images[0]?.externalId || "",
      currencyType: data.listingCurrency,
      currencySymbol: data.currencySymbol || "$",
      ownerAvatarUrl: data.ownerAvatar || "",
      ownerId: data.listingOwnerId,
      ownerFirstName: data.listingOwnerFirstName,
      ownerLastName: data.ownerLastName,
      priceHourly: data.prices[0].value,
      cleaningFeeSet: data.cleaningFee.obj_state !== "DEACTIVATED",
      cleaningFeeAmount: data.cleaningFee.value,
      dayRateDiscountSet:
        data.listingDayRateDiscount.obj_state !== "DEACTIVATED",
      dayRateDiscountPercent: data.listingDayRateDiscount.value,
      hostResponseTime: data.listingHostResponsiveness.hours,
      hostResponseBucket: data.listingHostResponsiveness.bucket,
      hostResponseStatus: data.listingHostResponsiveness.level_label,
      reviews: data.reviews || [],
      prices: data.prices,
      listingPrice: data.listingPrice,
      priceRange: data.priceRange,
      next_page: data.reviews?.length
        ? data.reviews[data.reviews.length - 1].nextPage
        : null,
    };

    let segmentedListing;
    if (
      typeof window !== "undefined" &&
      window?.analyticsIntegrations?.segmentListingObj
    ) {
      segmentedListing = window?.analyticsIntegrations?.segmentListingObj(
        segmentedListingProps,
        data.reviews || [],
      );
    }

    return segmentedListing;
  }, [data]);
};
